import BasicType from './BasicType';

export default class Location implements BasicType {
    public readonly address: string;

    public readonly lat: number;

    public readonly lng: number;

    public readonly country?: string;

    public readonly state?: string;

    public readonly postCode?: string;

    public readonly city?: string;

    public readonly street?: string;

    public readonly streetNumber?: string;

    constructor(
        address: string,
        lat: number,
        lng: number,
        country?: string,
        state?: string,
        postCode?: string,
        city?: string,
        street?: string,
        streetNumber?: string,
    ) {
        this.address = address;
        this.lat = lat;
        this.lng = lng;
        this.country = country;
        this.state = state;
        this.postCode = postCode;
        this.city = city;
        this.street = street;
        this.streetNumber = streetNumber;
    }

    public isEqualToJson(json: Record<string, any>): boolean {
        if (json === undefined) return false;

        return [
            this.address === json.address,
            this.lat === json.lat,
            this.lng === json.lng,
            this.country === json.country,
            this.state === json.state,
            this.postCode === json.postCode,
            this.city === json.city,
            this.street === json.street,
            this.streetNumber === json.streetNumber,
        ].every(test => test);
    }

    public equals(other: Location): boolean {
        return this.address === other.address && this.lat === other.lat && this.lng === other.lng;
    }

    public toString(): string {
        if (this.city || this.state) {
            if (!this.city) return this.state!;

            if (!this.state) return this.city!;

            if (this.city === this.state) return this.city;

            return `${this.city}, ${this.state}`;
        }

        return this.address;
    }

    public static fromJson(json: any): Location {
        return new Location(
            json.address,
            json.lat,
            json.lng,
            json.country,
            json.state,
            json.postCode,
            json.city,
            json.street,
            json.streetNumber,
        );
    }
}
